module.exports = __webpack_public_path__ + "static/serverless-b3f9ca2a009afee0f5fcf135652865b1.png";